import React from 'react';
import { View, Text, ScrollView, FlatList, Image } from 'react-native';

// Animated components - just pass through to RN equivalents
const Animated = {
  View,
  Text,
  ScrollView,
  FlatList,
  Image,
  createAnimatedComponent: (comp: any) => comp,
};

// Shared values
export function useSharedValue(initial: any) {
  const ref = React.useRef({ value: initial });
  return ref.current;
}

export function useDerivedValue(updater: () => any) {
  return { value: updater() };
}

// Animated styles - return empty object
export function useAnimatedStyle(updater: () => any) {
  try {
    return updater();
  } catch {
    return {};
  }
}

// Gesture handler
export function useAnimatedGestureHandler(handlers: any) {
  return handlers;
}

// Animation functions - just return the value
export function withTiming(toValue: any, _config?: any, callback?: any) {
  if (callback) {callback(true);}
  return toValue;
}

export function withSpring(toValue: any, _config?: any, callback?: any) {
  if (callback) {callback(true);}
  return toValue;
}

export function withSequence(...values: any[]) {
  return values[values.length - 1];
}

export function withRepeat(animation: any) {
  return animation;
}

export function runOnJS(fn: (...args: any[]) => any) {
  return fn;
}

// Easing
export const Easing = {
  linear: (t: number) => t,
  ease: (t: number) => t,
  bezier: () => (t: number) => t,
  in: (easing: any) => easing,
  out: (easing: any) => easing,
  inOut: (easing: any) => easing,
};

// Logger config (no-ops)
export function configureReanimatedLogger(_config: any) {}
export const ReanimatedLogLevel = {
  warn: 1,
  error: 2,
  strict: 3,
};

// Layout animations (no-ops that return style-compatible objects)
export const FadeIn = { duration: () => FadeIn };
export const FadeOut = { duration: () => FadeOut };
export const SlideInRight = { duration: () => SlideInRight };
export const SlideOutLeft = { duration: () => SlideOutLeft };

export default Animated;
